import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Services/login.service';

@Component({
  selector: 'ppa-significado',
  templateUrl: './ppa-significado.component.html',
  styleUrls: ['./ppa-significado.component.css']
})
export class PPASignificadoComponent implements OnInit {

  constructor(private loginService: LoginService) { }

  ngOnInit() {
  }

  downloadArquivo() {
    this.loginService.download().subscribe(data => { 
      const fileURL = URL.createObjectURL(data);
      window.open(fileURL);
    });
  }  
}
